import {useMemo} from "react";
import useMediaQuery from "./useMediaQuery";
import useIsDesktop from "./useIsDesktop";

export default function useTopBarHeight() {
    const isTablet = useMediaQuery(`(min-width: 768px)`);
    const isDesktop = useIsDesktop();

    return useMemo(() => (isDesktop ? 108 : isTablet ? 70 : 63), [isDesktop, isTablet]);
}